module.exports = __webpack_public_path__ + "media/images/wendys-logo-blk-fe9022fdf6a4f6d8396ebde4109d1aa9.png";